import React, { useEffect, useState, useContext } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import Icon from "@mui/material/Icon";
import MDTypography from "components/MDTypography";

import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import { LanguageContext } from "App";

const SessionTherapistsTable = ({ Session, RemoveFromSession }) => {
  const { translations } = useContext(LanguageContext);
  const TableColumns = [
    { Header: translations.TypeName, accessor: "TypeName", align: "left" },
    { Header: translations.HourlyRate, accessor: "HourlyRate", align: "center" },
    { Header: translations.Quantity, accessor: "Quantity", width: "30%", align: "left" },
    { Header: translations.Remove, accessor: "Remove", align: "center" },
  ];

  const [TableDataRows, setTableDataRows] = useState([]);

  const MakeTableRow = (entry, type) => {
    return {
      TypeName: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {type.typeName}
        </MDTypography>
      ),
      HourlyRate: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          EGP{type.standardHourlyRate}
        </MDTypography>
      ),
      Quantity: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {entry.quantityNeeded}
        </MDTypography>
      ),
      Remove: (
        <MDButton onClick={() => RemoveFromSession(entry.id)} variant="gradient" color="dark">
          <Icon sx={{ fontWeight: "bold" }}>delete</Icon>
        </MDButton>
      ),
    };
  };

  const RefreshTable = (resList) => {
    var rows = [];
    resList.forEach((entry) => {
      rows.push(MakeTableRow(entry, entry.getTherapistType));
    });
    setTableDataRows(rows);
  };

  useEffect(() => {
    RefreshTable(Session.getTherapistTypes);
  }, []);

  return (
    <MDBox pt={3}>
      <DataTable
        table={{ columns: TableColumns, rows: TableDataRows }}
        isSorted={false}
        entriesPerPage={false}
        showTotalEntries={false}
        noEndBorder
      />
    </MDBox>
  );
};

export default SessionTherapistsTable;
